import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../../../@types/filter";
import { Paginated } from "../../../../../../@types/paginated";
import { apisiseci } from "../../../../../api";
import { useDefaultSearchParams } from "../../../../../../hooks/useSearchParams";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../@types/attendance-local-department-guiche";
import { AttendanceLocalDepartmentGuicheService } from "../../../../../../@types/attendance-local-department-guiche-service";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
    guiche?: AttendanceLocalDepartmentGuiche["id"]
};

export function useAttendanceLocalDepartmentGuicheServiceList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    return useQuery<Paginated<AttendanceLocalDepartmentGuicheService>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'department', 'guiche', 'service', 'list', params],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<AttendanceLocalDepartmentGuicheService>>(
                "/cms/servicos_guiches/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
